/*
 * File: 会议信息卡片
 * File Created: 2021-05-12 7:24:55 pm
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-06-12 3:42:35 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

<template>
  <div
    :class="{
      'meeting-info': true,
      'meeting-info-canceled': meetingStatus === 6 && endType === 3
    }">
    <div class="title">{{ topicOfLang }}</div>
    <div
      :class="meetingStatusTextClass">
      {{ meetingStatusDesc }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'meeting-info',
  props: {
    // 1-已建立，2-入场中，3-已开始，4-清场中，5-已结束，6-已取消；
    meetingStatus: Number,
    topic: {
      type: String,
      default: ''
    },
    topicI18n: String,
    endType: Number,
  },
  computed: {
    meetingStatusDesc() {
      let text = ''
      if (!this.meetingStatus) {
        return text
      }
      switch (this.meetingStatus) {
        case 1:
        case 2:
          text = this.$t('common.readyToStart')
          break;

        case 3:
          text = this.$t('common.ing')
          break;
        case 4:
          text = this.$t('common.finishedAuto')
          break;
        case 5:
          if(this.endType === 1) {
            text = this.$t('common.finishedAuto')
          } else {
            text = this.$t('common.finishedByPresenter')
          }
          break;

        case 6:
        if(this.endType === 3) {
            text = ''
          } else {
            text = this.$t('common.finishedByPresenter')
          }
          break;

        default:
          text = this.$t('common.readyToStart')
          break;
      }
      return text
    },
    meetingStatusTextClass() {
      let textClass = ['status']
      switch (this.meetingStatus) {
        case 1:
        case 2:
          textClass.push('orange')
          break;

        case 3:
          textClass.push('blue')
          break;

        case 4:
        case 5:
          textClass.push('gray')
          break;

        default:
          textClass.push('orange')
          break;
      }
      return textClass
    },
    // 多语言匹配标题
    topicOfLang(){
      const lang = this.$i18n.locale
      // zh-CN  en-US  ja-JP
      if(!this.topicI18n) return this.topic
      const {topicZh, topicEn, topicJa} = JSON.parse(this.topicI18n)
      console.log(lang, JSON.parse(this.topicI18n))
      if(topicZh && (
        lang === 'zh-CN'
        || (lang === 'en-US' && !topicEn)
        || (lang === 'ja-JP' && !topicEn && !topicJa)
      )) {
        console.log('展示中文')
        return topicZh
      } else if(topicEn && (
        lang === 'en-US'
        || (lang === 'zh-CN' && !topicZh)
        || (lang === 'ja-JP' && !topicJa)
      )) {
        console.log('展示英文')
        return topicEn
      } else if(topicJa) {
        console.log('展示日文')
        return topicJa
      } else {
        return this.topic
      }
    }
  },
}
</script>

<style lang='less' scoped>
  @cancelColor: #787878;
  @cancelColor2: #A3A3A3;
  @cancelColor3: #B9B9B9;
  @cancelColor4: #BCBCBC;
  .meeting-info {
    width: 100%;
    height: 94px;
    background-color: #fff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    overflow: hidden;
    margin-top: 15px;
    background-image: url('~@/assets/images/icons/meeting-bg.png');
    background-repeat: no-repeat;
    background-position: calc(100% - 5px) bottom;
    background-size: 48%;
    .title {
      font-size: 18px;
      font-weight: bold;
      text-align: left;
      margin-top: 24px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      padding: 0 24px;
      line-height: 24px;
      min-height: 24px;
      text-overflow: ellipsis;
    }
    .status {
      font-size: 12px;
      text-align: left;
      margin-top: 4px;
      padding: 0 24px;
    }
    .blue {
      color: #3696FF;
    }
    .orange {
      color: #FFCE50;
    }
    .gray {
      color: #BCBCBC;
    }
  }
  .meeting-info-canceled {
    background-image: url('~@/assets/images/icons/meeting-bg-cancel.png') !important;
    .title {
      color: @cancelColor;
    }

  }
</style>
